module.exports = __webpack_public_path__ + "img/logo_fine.e02fc3fe.png";